import * as React from "react";
import type { SVGProps } from "react";

const SvgMastercard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={34}
    viewBox="0 0 48 34"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        stroke="#E6E7E8"
        strokeWidth={0.72}
        d="M45.355.36a1.804 1.804 0 0 1 1.805 1.8v28.8a1.802 1.802 0 0 1-1.805 1.8H2.165a1.804 1.804 0 0 1-1.805-1.8V2.16A1.802 1.802 0 0 1 2.165.36z"
      />
      <path fill="#FF5F00" d="M19.913 10.458h7.562v12.181h-7.562z" />
      <path
        fill="#EB001B"
        d="M20.692 16.55a7.7 7.7 0 0 1 3-6.09c-3.22-2.496-7.845-2.133-10.623.835a7.665 7.665 0 0 0 0 10.51c2.778 2.968 7.403 3.332 10.623.836a7.7 7.7 0 0 1-3-6.092z"
      />
      <path
        fill="#F79E1B"
        fillRule="nonzero"
        d="M35.666 21.66v-.507h.12v-.105H35.5v.105h.113v.506h.053zm.554 0v-.612h-.086l-.1.437-.102-.437h-.086v.611h.062v-.462l.094.397h.065l.093-.397v.462z"
      />
      <path
        fill="#F79E1B"
        d="M36.401 16.55c0 2.965-1.717 5.67-4.422 6.967a7.95 7.95 0 0 1-8.287-.878 7.71 7.71 0 0 0 3.002-6.09 7.7 7.7 0 0 0-3.002-6.091 7.95 7.95 0 0 1 8.287-.878c2.705 1.296 4.422 4.001 4.422 6.967v.002z"
      />
    </g>
  </svg>
);
export default SvgMastercard;
